import { render, staticRenderFns } from "./CbsCellLabel.vue?vue&type=template&id=823b5760&scoped=true"
import script from "./CbsCellLabel.vue?vue&type=script&lang=js"
export * from "./CbsCellLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823b5760",
  null
  
)

export default component.exports